import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/namespace/entity';
const moduleAjaxService = 'service'
const api = {
    namespaced: true,
    state: {},
    actions: {}
};

export default api
